import type { RolloutGroup } from '@/shared/lib/constants/rolloutGroup';

export type RelyingPartySettingType = {
  CarePlanUrl: string;
  CCMCarePlanUrl: string;
  sendDailyRPMEmailTo: {
    sendEmail: boolean;
    email: string;
    bccEmail: string[];
  }[];
  AdditionalFeatures: {
    kpi: boolean;
    coPilot: boolean;
    chartReview: boolean | string;
    aiNotesSummary: boolean | string;
    ccmBillingEnabled: boolean;
    ccmOnlyEnrollment?: boolean | string;
    playfulFeedbackEnabled?: boolean | string;
    aiSearch?: boolean | string;
    engagementTimeTracking?: boolean | string;
    defaultAiSummaryLaunchMethod?: 'DEVICE_AI_SUMMARY' | 'ALL_DEVICES_AI_SUMMARY' | 'NO_AI_SUMMARY';
  };
  PriorityScoreThreshold: number;
  PatientPrioritizationFeatureEnabled: boolean;
  PatientPrioritizationInsuranceFeatureEnabled: boolean;
  NoReadingsTextRemindersEnabled: boolean;
  PioneerRx: {
    enabled: boolean;
    patientOnboarding: boolean;
    providerOnboarding: boolean;
  };
  /**
   * Canary enrolment, written by Company Setup. This is the admin editing surface -- route on the
   * resolved `rolloutGroup` query instead, which validates the value.
   */
  rolloutGroup?: RolloutGroup;
};

export enum FeatureFlag {
  SHOW_CHART_REVIEW = 'chartReview',
  SHOW_AI_NOTES_SUMMARY = 'aiNotesSummary',
  PLAYFUL_FEEDBACK = 'playfulFeedbackEnabled',
  AI_SEARCH = 'aiSearch',
  ENGAGEMENT_TIME_TRACKING = 'engagementTimeTracking',
  CCM_ONLY_ENROLLMENT = 'ccmOnlyEnrollment'
}
